import {getQueryParams} from "@util/api";
import {toNumber} from "lodash";

const {latitude, longitude} = LOC?.mapSettings.defaultCoords || {}
const queryParams = getQueryParams(new URL(window.location)?.search);

if (!queryParams.pages) {
    queryParams.page = 1;
}

export default () => ({
    age: '',
    apiParams: {},
    coords: {
        lat: toNumber(latitude || 0),
        lng: toNumber(longitude || 0),
    },
    defaultCoords: {
        lat: toNumber(latitude || 0),
        lng: toNumber(longitude || 0),
    },
    locationName: '',
    loading: false,
    query: queryParams,
    resultsValues: {
        error: false,
        maxPages: 0,
        page: 1,
        posts: [],
        total: 0,
    },
    sex: '',
    showResults: [],
    status: '',
    taId: 0,
    total: 0,
})
